export const Paths = Object.freeze({
  home: '/',
  login: '/login',
  groups: '/groups',
  group: '/groups/:groupId',
  summary: '/groups/:groupId/summary',
  employees: '/groups/:groupId/employees',
  newEmployeeRegistration: '/groups/:groupId/employees/registration',
  employeeProfileIdCard: '/groups/:groupId/employees/:id/id-card',
  dependentProfileIdCard:
    '/groups/:groupId/employees/:id/dependents/:dependentId/id-card',
  employeeProfile: '/groups/:groupId/employees/:id',
  editEmployeeProfile: '/groups/:groupId/employees/:id/edit',
  disenrollEmployee: '/groups/:groupId/employees/:id/disenroll',
  newDependentRegistration:
    '/groups/:groupId/employees/:id/dependents/registration',
  dependentProfile: '/groups/:groupId/employees/:id/dependents/:dependentId',
  editDependentProfile:
    '/groups/:groupId/employees/:id/dependents/:dependentId/edit',
  billing: '/groups/:groupId/billing',
  settings: '/groups/:groupId/settings',
  documentsAndForms: '/groups/:groupId/documents',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  claims: '/groups/:groupId/claims',
  temporaryLogin: '/temporary-login',
  changePassword: '/change-password',
  quotes: '/quotes',
  reporting: '/groups/:groupId/reporting',
  superuser: '/superuser',
  viewQuote: (quoteId?: string | null) =>
    quoteId ? `/quotes/view/${quoteId}` : '/quotes/view/:quoteId',
  quoteForm: (quoteId?: string | null) =>
    `/quotes/form${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormBasicInfo: (quoteId?: string | null) =>
    `/quotes/form/basic-info${quoteId ? `?quoteId=${quoteId}` : ''}`,
  basicInfoStep1: (quoteId?: string | null) =>
    `/quotes/form/basic-info/step1${quoteId ? `?quoteId=${quoteId}` : ''}`,
  basicInfoStep2: (quoteId?: string | null) =>
    `/quotes/form/basic-info/step2${quoteId ? `?quoteId=${quoteId}` : ''}`,
  basicInfoStep3: (quoteId?: string | null) =>
    `/quotes/form/basic-info/step3${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormPlanInfo: (quoteId?: string | null) =>
    `/quotes/form/plan-info${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormPlanInfoStep1: (quoteId?: string | null) =>
    `/quotes/form/plan-info/step1${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormPlanInfoStep2: (quoteId?: string | null) =>
    `/quotes/form/plan-info/step2${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormCensusInfo: (quoteId?: string | null) =>
    `/quotes/form/census-info${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormQuoteDetails: (quoteId?: string | null) =>
    `/quotes/form/details${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormQuoteDetailsStep1: (quoteId?: string | null) =>
    `/quotes/form/details/step1${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormQuoteDetailsStep2: (quoteId?: string | null) =>
    `/quotes/form/details/step2${quoteId ? `?quoteId=${quoteId}` : ''}`,
  quoteFormQuoteReview: (quoteId?: string | null) =>
    `/quotes/form/review${quoteId ? `?quoteId=${quoteId}` : ''}`
})
